import { NgModule } from '@angular/core';
import { SharedModule } from '@/shared/shared.module';

import { OptaWidgetActionAreasComponent } from './widgets/action-areas/action-areas.component';
import { OptaWidgetAttackingThirdsComponent } from './widgets/attacking-thirds/attacking-thirds.component';
import { OptaWidgetAveragePositionsComponent } from './widgets/average-positions/average-positions.component';
import { OptaWidgetChalkboardComponent } from './widgets/chalkboard/chalkboard.component';
import { OptaWidgetCommentaryComponent } from './widgets/commentary/commentary.component';
import { OptaWidgetDefensiveZonesComponent } from './widgets/defensive-zones/defensive-zones.component';
import { OptaWidgetGoalReplayComponent } from './widgets/goal-replay/goal-replay.component';
import { OptaWidgetHeatmapComponent } from './widgets/heatmap/heatmap.component';
import { OptaWidgetMatchStatsTeamGraphComponent } from './widgets/match-stats-team-graph/match-stats-team-graph.component';
import { OptaWidgetMatchStatsTeamProGraphComponent } from './widgets/match-stats-team-graph-pro/match-stats-team-graph-pro.component';
import { OptaWidgetMatchdayLiveComponent } from './widgets/matchday-live/matchday-live.component';
import { OptaWidgetMatchPlayerCompareComponent } from './widgets/match-player-compare/match-player-compare.component';
import { OptaWidgetCompetitionStatsComponent } from './widgets/competition-stats/competition-stats.component';
import { OptaWidgetTeamRankingComponent } from './widgets/team-ranking/team-ranking.component';
import { OptaWidgetSeasonTeamstatsComponent } from './widgets/season-team-stats/season-team-stats.component';
import { OptaWidgetSeasonPlayerStatsComponent } from './widgets/season-player-stats/season-player-stats.component';
import { OptaWidgetPlayerRatingsComponent } from './widgets/player-ratings/player-ratings.component';
import { OptaWidgetPlayerCompareComponent } from './widgets/player-compare/player-compare.component';
import { OptaWidgetExpectedGoalsComponent } from './widgets/expected-goals/expected-goals.component';
import { OptaWidgetExpectedGoalsSeasonComponent } from './widgets/expected-goals-season/expected-goals-season.component';
import { OptaWidgetPenaltyTouchMapSeasonComponent } from './widgets/penalty-touch-map/penalty-touch-map.component';
import { OptaWidgetMatchTeamsheetComponent } from './widgets/match-teamsheet/match-teamsheet.component';
import { OptaWidgetPassMatrixComponent } from './widgets/pass-matrix/pass-matrix.component';
import { OptaWidgetPenaltyHistoryComponent } from './widgets/penalty-history/penalty-history.component';

const OPTA_COMPONENTS = [
    OptaWidgetActionAreasComponent,
    OptaWidgetAttackingThirdsComponent,
    OptaWidgetAveragePositionsComponent,
    OptaWidgetChalkboardComponent,
    OptaWidgetCommentaryComponent,
    OptaWidgetDefensiveZonesComponent,
    OptaWidgetGoalReplayComponent,
    OptaWidgetHeatmapComponent,
    OptaWidgetMatchStatsTeamGraphComponent,
    OptaWidgetMatchStatsTeamProGraphComponent,
    OptaWidgetMatchdayLiveComponent,
    OptaWidgetMatchPlayerCompareComponent,
    OptaWidgetCompetitionStatsComponent,
    OptaWidgetTeamRankingComponent,
    OptaWidgetSeasonTeamstatsComponent,
    OptaWidgetSeasonPlayerStatsComponent,
    OptaWidgetPlayerRatingsComponent,
    OptaWidgetPlayerCompareComponent,
    OptaWidgetExpectedGoalsComponent,
    OptaWidgetExpectedGoalsSeasonComponent,
    OptaWidgetPenaltyTouchMapSeasonComponent,
    OptaWidgetMatchTeamsheetComponent,
    OptaWidgetPassMatrixComponent,
    OptaWidgetPenaltyHistoryComponent,
];

@NgModule({
    declarations: OPTA_COMPONENTS,
    imports: [SharedModule],
    exports: OPTA_COMPONENTS,
})
export class OptaModule {}
